import { Dropdown } from '@shared/ui/Dropdown';
import { isLocalPreview, localPreviewRole } from '@shared/lib/localPreview';
import styles from './LocalPreviewBar.module.css';
export function LocalPreviewBar() {
  if (!isLocalPreview()) return null;
  return <aside className={styles.bar} aria-label="Local preview controls">
    <span><strong>Local preview</strong><small>Sample data · No real payments</small></span>
    <label>View as <Dropdown size="compact" variant="normal" aria-label="Preview account" value={localPreviewRole()} onValueChange={(event) => {
      localStorage.setItem('dev:previewRole', event);
      window.location.reload();
    }}><option value="admin">Admin</option><option value="seller">My seller</option><option value="demo">Demo shop</option><option value="guest">Browser sign-in</option></Dropdown></label>
  </aside>;
}
